// extracted by mini-css-extract-plugin
export default {"container":"style_container__EBWys","notification":"style_notification__5W-R8","error":"style_error__4BudA","success":"style_success__WC6Ig","pending":"style_pending__M6Uzn"};